import { useMemo, useState } from 'react';
import { KeenIcon } from '@/components/keenicons';

/**
 * Grouped, searchable list of merge fields. Clicking one inserts it at the
 * cursor through the editor ref.
 */
const MergeFieldPicker = ({ groups = [], onInsert, disabled = false, title = 'Merge fields' }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const needle = search.trim().toLowerCase();
    return groups
      .map((group) => ({
        ...group,
        fields: (group.fields || []).filter(
          (f) => !needle || f.label.toLowerCase().includes(needle) || f.token.toLowerCase().includes(needle)
        ),
      }))
      .filter((group) => group.fields.length > 0);
  }, [groups, search]);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title text-sm">{title}</h3>
      </div>
      <div className="card-body">
        <div className="relative mb-3">
          <KeenIcon icon="magnifier" className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-500" />
          <input
            className="input input-sm pl-8 w-full"
            placeholder="Search fields…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="max-h-[520px] overflow-y-auto pr-1">
          {filtered.length === 0 && <p className="text-xs text-gray-500">No fields match.</p>}
          {filtered.map((group) => (
            <div key={group.key} className="mb-3">
              <div className="text-2xs uppercase tracking-wide text-gray-500 font-semibold mb-1">{group.label}</div>
              <div className="flex flex-wrap gap-1">
                {group.fields.map((field) => (
                  <button
                    key={field.token}
                    type="button"
                    disabled={disabled}
                    title={`{{${field.token}}}`}
                    onClick={() => onInsert?.(field.token, field.label)}
                    className="btn btn-xs btn-light !py-0.5 !px-1.5 text-xs disabled:opacity-40"
                  >
                    {field.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { MergeFieldPicker };
